import React from 'react';
import ReactDOM from 'react-dom';
import InternetSearchResults from './internet/InternetSearchResults';

ReactDOM.render(
	<React.StrictMode>
		<InternetSearchResults />
	</React.StrictMode>,
	document.querySelector('#cdc-search-results')
);
